import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const BulbIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Bulb",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 2c-4.73.02-8.56 3.85-8.56 8.58 0 1.09.2 2.13.57 3.08l-.02-.06c.29.73.64 1.37 1.06 1.95l-.02-.03q.075.12.15.21s.12.15.12.15a6.36 6.36 0 0 1 1.29 3.87v.33-.02c0 .26.05.51.13.74v-.02c.31.75 1.04 1.26 1.89 1.26h6.74c.87 0 1.61-.54 1.9-1.31.08-.23.13-.49.13-.75v-.24c0-1.46.49-2.81 1.32-3.88v.02l.13-.18c.05-.06.09-.12.13-.18.4-.56.75-1.2 1.02-1.87l.02-.06c.35-.9.55-1.94.55-3.03a8.58 8.58 0 0 0-8.56-8.58Zm3.01 10.97a8.3 8.3 0 0 0-2.71 4.39v.06c-.09.39-.43.69-.83.69h-.16a.84.84 0 0 1-.69-.82c0-.05 0-.1.01-.15a9.74 9.74 0 0 1 1.96-4.06v.02h-.3c-.89 0-1.78.04-2.65.13h.11-.11c-.31 0-.58-.17-.72-.41a.852.852 0 0 1 .05-.92c.42-.58.94-1.21 1.47-1.85.69-.8 1.36-1.68 1.98-2.59l.06-.1c.14-.27.42-.46.74-.46.17 0 .33.05.46.14.25.15.41.41.41.72 0 .16-.05.31-.12.44-.72 1.08-1.44 2.02-2.21 2.91l.03-.04-.28.33c.3-.01.66-.02 1.01-.02.75 0 1.5.04 2.23.1h-.09c.34.04.6.28.69.6a.839.839 0 0 1-.33.91Zm.02 14.11h-6.02c-.46 0-.84.37-.84.84s.37.84.84.84h1.81a1.25 1.25 0 0 0 2.5 0h1.67c.46 0 .84-.37.84-.84s-.37-.84-.84-.84h.03Zm.53-1.67h-7.1c-.46 0-.84-.37-.84-.84s.37-.84.84-.84h7.1c.46 0 .84.37.84.84s-.37.84-.84.84"
    })
  }));
};